<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/photos">Photos</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
          <select-input v-model="form.project_id" :error="form.errors.project_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Project">
            <option :value="null" />
            <option v-for="project in projects" :key="project.id" :value="project.id">{{ project.name }}</option>
          </select-input>
        </div>
        <div class="flex flex-wrap p-8 mb-8">
          <figure class="max-w-lg">
            <img class="h-auto max-w-full rounded-lg" :src="photo.url" alt="image description">
          </figure>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!photo.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete photo</button>
          <div class="ml-auto flex items-center bg-gray-50 border-t border-gray-100">
            <Link class="text-blue-600 hover:underline mr-2" tabindex="-1" href="/photos">Go back</Link>
            <loading-button :loading="form.processing" class="btn-indigo" type="submit">Update photo</loading-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    SelectInput,
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  props: {
    photo: Object,
    projects: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.photo.name,
        project_id: this.photo.project_id,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/photos/${this.photo.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this photo?')) {
        this.$inertia.delete(`/photos/${this.photo.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this photo?')) {
        this.$inertia.put(`/photos/${this.photo.id}/restore`)
      }
    },
  },
}
</script>
